function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { forwardRef } from 'react';
import { node, bool, string } from 'prop-types';
import cn from 'classnames';
/**
 * ListItem component.
 */

var ListItem = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      className = _ref.className,
      separator = _ref.separator,
      separatorBottom = _ref.separatorBottom,
      role = _ref.role,
      gtmLabel = _ref.gtmLabel,
      restProps = _objectWithoutProperties(_ref, ["children", "className", "separator", "separatorBottom", "role", "gtmLabel"]);

  return /*#__PURE__*/React.createElement("li", _extends({}, restProps, {
    className: cn(className, 'list-item', separator && 'list-item--separator', separatorBottom && 'list-item--separator-bottom'),
    "data-gtm-class": gtmLabel,
    role: role,
    ref: ref
  }), children);
});
ListItem.displayName = 'ListItem';
ListItem.defaultProps = {
  children: [],
  separator: false,
  separatorBottom: false,
  className: null,
  role: null,
  gtmLabel: null
};
ListItem.propTypes = {
  /** The children to be rendered within the list item. */
  children: node,

  /** Additional classes to be added to the root of the component. */
  className: string,

  /** Use the list item as a presentational separator. */
  separator: bool,

  /** Use the list item as a presentational bottom separator. */
  separatorBottom: bool,

  /** An ARIA role. */
  role: string,

  /** A label to be used for GTM tracking. */
  gtmLabel: string
};
export default ListItem;